import SFullPage from './style.module.scss';
import type { IFeatureWithDescAndPic } from '@/utils/const/products/interface';
import { WebPNextImage as Image } from '@/components/WebPImage';
import FadeIn from '@/components/commonComponents/fadeIn';

interface FlattenCardsForMobileProps {
  list: IFeatureWithDescAndPic[];
  backgroundInner?: string;
  backgroundOuter?: string;
}

const Card = ({
  title,
  subTitle,
  picUrl,
  backgroundInner,
}: IFeatureWithDescAndPic & {
  backgroundInner: string;
}) => {
  return (
    <FadeIn>
      <div
        className={SFullPage['card']}
        style={{ background: backgroundInner }}
      >
        <div className={SFullPage['title']}>{title}</div>
        <div className={SFullPage['desc']}>{subTitle}</div>
        <div className={SFullPage['image']}>
          <Image src={picUrl} layout="fill" alt={title} />
        </div>
      </div>
    </FadeIn>
  );
};

const FlattenCardsForMobile = ({
  list,
  backgroundInner,
  backgroundOuter,
}: FlattenCardsForMobileProps) => {
  return (
    <div style={{ background: backgroundOuter }}>
      {list.map((item, index) => {
        const { title, subTitle, picUrl } = item;
        return (
          <Card
            title={title}
            subTitle={subTitle}
            picUrl={picUrl}
            backgroundInner={backgroundInner}
            key={index}
          />
        );
      })}
    </div>
  );
};

export default FlattenCardsForMobile;
